/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupHeader from "vux/src/components/popup-header/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import mapView from '@/components/GaoDeMap/mapView';
import TAddressOnline from '@/components/TAddressOnline';
import utils from '@/utils/utils';
export default {
  components: {
    TAddressOnline: TAddressOnline,
    Cell: Cell,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupHeader: PopupHeader,
    Checklist: Checklist,
    mapView: mapView
  },
  props: {
    type: {
      type: [String, Number]
    },
    title: {
      type: String
    },
    defaultAddress: {
      type: String
    },
    defaultLatLong: {
      type: Array
    },
    defaultCode: {
      type: Array
    },
    placeholder: {
      type: String,
      default: i18n.tc("237")
    }
  },
  data: function data() {
    return {
      addrType: 1,
      isShow: false,
      isShowXAddress: false,
      isGetDefault: false,
      showtMapAddress: false,
      checklist: [],
      areaCode: [],
      areaName: [],
      selected: {
        type: '',
        address: '',
        longitude: '',
        latitude: '',
        code: '',
        name: ''
      },
      center: []
    };
  },
  computed: {
    // 是否已选择地址
    isUsed: function isUsed() {
      if (this.selected.type && (this.selected.type === 1 || this.selected.type === 2)) {
        if (this.selected.type === 1 && this.selected.longitude && this.selected.latitude) {
          return true;
        } // 存在经纬度
        if (this.selected.type === 2 && this.selected.code.length > 0) {
          return true;
        } // 存在 省市区 code
      }
      return false;
    }
  },
  filters: {
    realAddress: function realAddress(val, selected) {
      if (val === 1) return selected.address;
      if (val === 2) {
        return selected.name ? selected.name.join(' ') : '';
      }
    }
  },
  watch: {
    defaultCode: {
      handler: function handler(val) {
        var _this = this;
        if (val && (val[0] || val[1] || val[2])) {
          this.isGetDefault = true;
          if (this.type === 2) {
            this.addrType = this.type;
            this.selected.type = this.type;
            this.selected.code = this.defaultCode;
            setTimeout(function () {
              _this.selected.name = _this.areaName;
            }, 100);
          }
        }
      },
      immediate: true
    },
    type: {
      handler: function handler(val) {
        if (val) {
          this.addrType = val;
          this.selected.type = val;
        }
      },
      immediate: true
    },
    defaultAddress: {
      handler: function handler(val) {
        if (this.type === 1) {
          this.addrType = this.type;
          this.selected.type = this.type;
          this.selected.address = this.defaultAddress || '';
        }
      },
      immediate: true
    },
    defaultLatLong: {
      handler: function handler(val) {
        if (this.type === 1) {
          this.selected.longitude = this.defaultLatLong[0] || '';
          this.selected.latitude = this.defaultLatLong[1] || '';
        }
      },
      immediate: true
    }
  },
  methods: {
    showName: function showName(name) {
      this.areaName = name;
      this.selected.name = name;
    },
    onChange: function onChange(code, name) {
      this.addrType = 2;
      this.areaName = name;
      this.areaCode = code;
      this.selected.name = name;
      this.selected.type = this.addrType;
      this.selected.code = this.areaCode;
      this.$emit('on-change', this.selected);
    },
    // 级联滑动 picker 时触发
    onShadowChange: function onShadowChange(code, name) {
      this.areaCode = code;
      this.areaName = name;
      // 外部传入默认值后 更新数据
      if (this.isGetDefault) {
        this.selected.code = this.areaCode;
        this.selected.name = this.areaName;
        this.isGetDefault = false;
      }
    },
    // 隐藏级联地址
    showXAddress: function showXAddress() {
      var _this2 = this;
      setTimeout(function () {
        _this2.isShowXAddress = !_this2.isShowXAddress;
      }, 100);
    },
    // 级联地址 完成按钮触发事件
    submit: function submit(e) {
      if (e) {
        this.addrType = 2;
        this.selected.type = this.addrType;
        this.selected.code = this.areaCode;
        this.selected.name = this.areaName;
        this.$emit('on-change', this.selected);
      }
    },
    selectMapAddress: function selectMapAddress(res) {
      this.addrType = 1;
      this.selected.type = this.addrType;
      this.selected.address = res.address + (res.name ? "(".concat(res.name, ")") : '');
      this.selected.longitude = res.position[0] + '';
      this.selected.latitude = res.position[1] + '';
      this.$emit('on-change', this.selected);
      this.showtMapAddress = false;
    }
  },
  created: function created() {
    var _this3 = this;
    utils.getLocation().then(function (res) {
      console.log('AutoConsole ~ res:', res);
      _this3.center = res.coor || [];
    }).catch(function (e) {
      return console.log(e);
    });
  }
};